/**
 * Controller for managing notification settings.
 */
function NotificationsSettingsCtrl() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
NotificationsSettingsCtrl.$inject = ['$scope', '$state', 'NotificationService', 'AuthService', '$Loading', '$message'];


NotificationsSettingsCtrl.prototype = {
    //@type {NotificationSettingsModel} settings - Current notification settings
    settings: null, // Current notification settings

    /**
     * Initializes the controller with necessary services and loads data.
     * @param {angular.IScope} $scope - Angular scope for binding
     * @param {ui.IStateService} $state - Service for state management
     * @param {NotificationService} NotificationService - Service for handling notifications
     * @param {AuthService} AuthService - Service for authentication
     * @param {$Loading} $Loading - Service for loading indicators
     * @param {$message} $message - Service for displaying messages
     */
    init: function ($scope, $state, NotificationService, AuthService, $Loading, $message) {
        // Assign the controller's scope to the Angular scope for binding
        this.$scope = $scope;
        this.$state = $state;
        this.notificationService = NotificationService;
        this.auth = AuthService;
        this.$Loading = $Loading;
        this.$message = $message;
        this.showNewDocument = this.auth.getAuthenticatedUser().LicenseType === 'Manage';


        // Load notification settings
        this.notificationService.getNotificationSettings()
            .then((settings) => {
                // Store the loaded settings
                this.settings = settings;
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    },

    /**
     * Navigates back to the notifications list.
     */
    back: function () {
        this.$state.go('internal.notifications');
    },

    /**
     * Saves the current notification settings.
     */
    save: function () {
        // Save settings and navigate back on success
        this.notificationService.saveNotificationSettings(this.settings)
            .then(() => {
                this.back();
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    },

    /**
     * Checks if the settings can be saved.
     * @returns {boolean} True if settings can be saved; otherwise, false.
     */
    canSave: function () {
        return !this.settings || this.settings.EventExpenseEmails || this.settings.EventExpensePushNotifications;
    }
};


// Register the controller with the Angular module
angular.module('internal.notifications').controller('NotificationsSettingsCtrl', NotificationsSettingsCtrl);